import React from 'react';
import WidgetCard from "../../../../component/instance/widget";
import { ObjectWidgetsProps } from "../../../../types/ObjectBrowser/ComponentTypes";

const ObjectWidgets: React.FC<ObjectWidgetsProps> = ({ selectedObject, objectAnalysis }) => {
    if (!selectedObject) return null;
    const rowsNr = selectedObject.rows ?? 0;

    return (
        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-4 flexlist">
            <WidgetCard
                name={selectedObject.objectType !== "Index" ? "Table Size" : "Index Size"}
                iconClassName="time"
                icon="fa-database"
                value={(() => {
                    const sizeBytes = selectedObject.objectType === "Index" ? selectedObject.indexsizebytes : selectedObject.tablesizebytes;
                    return <span>{sizeBytes != null ? (sizeBytes / 1024 / 1024).toFixed(2) : "-"}</span>;
                })()}
                cardTooltipText={selectedObject.objectType !== "Index" ? "Total Table Size" : "Total Index Size"}
            />
            {selectedObject.rows != null && (
                <WidgetCard
                    name="Estimated Rows"
                    iconClassName="executions"
                    icon="fa-list"
                    value={Number(rowsNr) > -1 ? rowsNr : 0}
                    cardTooltipText="Estimated number of rows in the table"
                />
            )}
            {selectedObject.objectType !== "Index" && (
                <WidgetCard
                    name="Insights"
                    iconClassName="insights"
                    icon="fa-chart-line"
                    value={objectAnalysis?.length || 0}
                    cardTooltipText="Total number of insights"
                />
            )}
        </div>
    );
};

export default ObjectWidgets; 